import Axios from "axios";

export default function getUsers(
  setUsers,
  setPaginationResult,
  page = 0,
  search = "",
  oldTown = "",
  newTown = ""
) {
  return (dispatch) => {
    dispatch({
      type: "Loading",
      payload: true,
    });
    Axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/getAllGuests`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      params: { page, search, oldTown, newTown },
    })
      .then((response) => {
        setUsers(response.data.data);
        setPaginationResult(response?.data?.pagination);
        return dispatch({
          type: "Loading",
          payload: false,
        });
      })
      .catch((err) => {
        dispatch({
          type: "Loading",
          payload: false,
        });
        setUsers([]);
        setPaginationResult({ totalPages: 0, totalItems: 0, itemsPerPage: 0, currentPage: 0 });
      });
  };
}
